import { useCallback, useLayoutEffect, useRef, useState } from "react";
var useFillViewportHeight = function (bottomReserve, minHeight) {
    if (bottomReserve === void 0) { bottomReserve = 52; }
    if (minHeight === void 0) { minHeight = 240; }
    var ref = useRef(null);
    var _a = useState("calc(100dvh - ".concat(bottomReserve + 220, "px)")), maxHeight = _a[0], setMaxHeight = _a[1];
    var measure = useCallback(function () {
        var el = ref.current;
        if (!el)
            return;
        var top = el.getBoundingClientRect().top + window.scrollY;
        var next = Math.max(minHeight, Math.floor(window.innerHeight - top - bottomReserve));
        setMaxHeight(function (prev) { return (prev === "".concat(next, "px") ? prev : "".concat(next, "px")); });
    }, [bottomReserve, minHeight]);
    useLayoutEffect(measure);
    useLayoutEffect(function () {
        window.addEventListener("resize", measure);
        return function () { return window.removeEventListener("resize", measure); };
    }, [measure]);
    return { ref: ref, maxHeight: maxHeight };
};
export default useFillViewportHeight;
